module.exports = __webpack_public_path__ + "img/8.1f7c3022.jpg";